import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CloudIcon, Loader2Icon } from 'lucide-react';
import { formatDistanceToNowStrict } from 'date-fns';
import { usePortal } from '../../contexts/PortalContext';
export function SaveIndicator({
  compact = false
}: {
  compact?: boolean;
}) {
  const {
    saving,
    savedAt
  } = usePortal();
  const ago = Date.now() - savedAt < 60000 ? 'just now' : `${formatDistanceToNowStrict(savedAt)} ago`;
  return <div className="flex items-center gap-1.5 text-[13px] text-ink-500" aria-live="polite" data-id="element-695" data-mp="3inyd9fkk4n05">
      <AnimatePresence mode="wait" initial={false} data-id="element-696" data-mp="3mpjn0s1sol64">
        {saving ? <motion.span key="saving" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} className="flex items-center gap-1.5" data-id="element-697" data-mp="38v92yo0qtf6e">
            <Loader2Icon className="h-3.5 w-3.5 animate-spin" aria-hidden data-id="element-698" data-mp="5eaiicte3ore" />
            Saving…
          </motion.span> : <motion.span key="saved" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} className="flex items-center gap-1.5" data-id="element-699" data-mp="a7d3vxo0jrwi">
            <CloudIcon className="h-3.5 w-3.5 text-positive-500" aria-hidden data-id="element-700" data-mp="3lze1i94kzxop" />
            {compact ? 'Saved' : `Saved automatically · ${ago}`}
          </motion.span>}
      </AnimatePresence>
    </div>;
}